// api.js — DRHP Workspace backend calls (isolated module).
// Base URL from REACT_APP_BACKEND_URL; every route is under /api/drhp-workspace
// so it never collides with the rest of the IPOLabs API. No app/auth coupling.

const BASE = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BASE}/api/drhp-workspace`;

const json = (r) => r.json();

export const api = {
  chapters: () => fetch(`${API}/chapters`).then(json),

  getDoc: (ws, ch) => fetch(`${API}/doc/${ws}/${ch}`).then(json),
  saveDoc: (body) =>
    fetch(`${API}/doc`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(json),

  comments: (ws, ch) => fetch(`${API}/comments/${ws}/${ch}`).then(json),
  addComment: (body) =>
    fetch(`${API}/comments`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(json),
  resolveComment: (id) =>
    fetch(`${API}/comments/resolve`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    }).then(json),

  revisions: (ws, ch) => fetch(`${API}/revisions/${ws}/${ch}`).then(json),
  recordRevision: (body) =>
    fetch(`${API}/revisions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(json),

  sebi: (ws, ch) => fetch(`${API}/sebi/${ws}/${ch}`).then(json),
  audit: (ws, ch) => fetch(`${API}/audit/${ws}/${ch}`).then(json),
  versions: (ws, ch) => fetch(`${API}/versions/${ws}/${ch}`).then(json),

  uploadImage: async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(`${API}/upload-image`, { method: "POST", body: fd });
    if (!res.ok) throw new Error("upload failed");
    return (await res.json()).url;
  },

  importDocx: async (file, ctx) => {
    const fd = new FormData();
    fd.append("file", file);
    Object.entries(ctx).forEach(([k, v]) => fd.append(k, v));
    return fetch(`${API}/import-docx`, { method: "POST", body: fd }).then(json);
  },

  exportDocx: async (body, force = false) => {
    const res = await fetch(`${API}/export-docx`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...body, force }),
    });
    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) return await res.json();
    return { blob: await res.blob() };
  },

  // ── DRHP Master Data (single source of truth) ──
  getMaster: (ws) => fetch(`${API}/master/${ws}`).then(json),
  saveMaster: (ws, body) =>
    fetch(`${API}/master/${ws}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(json),
  syncMaster: (ws, body) =>
    fetch(`${API}/master/${ws}/sync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
    }).then(json),
  approveMaster: (ws, body) =>
    fetch(`${API}/master/${ws}/approve`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
    }).then(json),
  linkedMap: (ws) => fetch(`${API}/master/${ws}/linked-map`).then(json),
  auditRecent: (ws) => fetch(`${API}/audit-recent/${ws}`).then(json),

  exportFull: async (ws, body) => {
    const res = await fetch(`${API}/export-full/${ws}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
    });
    return { blob: await res.blob() };
  },
};
